import { gql } from '@apollo/client';

// Full catalog of Ninetailed experiences + audiences for the PREVIEW WIDGET only.
//
// The `NinetailedPreviewPlugin` lists every experience and audience in its editor
// panels from the `experiences`/`audiences` arrays it is constructed with — it does
// NOT discover them from the API. Passing empty arrays leaves both panels blank, so
// we fetch the whole catalog here and hand it to the plugin (see
// `useNinetailedPreviewCatalog`). This query runs client-side through the
// `/api/graphql?preview=true` proxy (preview token, draft entries) and ONLY when
// preview mode is active, so it never touches the production render path.
//
// Experience fields mirror `MainBannerExperiences` exactly (proven to exist and
// exactly what `mapExperiences` consumes); variants only need `sys.id` for the
// widget's variant-forcing, so they are kept minimal. Audience carries the fields
// `mapAudiences` maps to the widget's `{ id, name, description }` shape.
//
// The item-level `sys.id` on experiences and audiences is the Contentful ENTRY id
// (distinct from the `ntExperienceId`/`ntAudienceId` Ninetailed field values). It
// powers the preview widget's "Go to editor" deep-links into the Contentful entry
// editor: the plugin's callbacks receive `nt_experience_id`/`nt_audience_id`, which
// `mapEntryIds` pairs back to these `sys.id`s so the provider can build the URL.
export const NINETAILED_CATALOG_QUERY = gql`
  query NINETAILED_CATALOG($limit: Int = 100, $variantLimit: Int = 10) {
    ntExperienceCollection(limit: $limit) {
      items {
        sys {
          id
        }
        ntExperienceId
        ntName
        ntType
        ntConfig
        ntAudience {
          ntAudienceId
          ntName
        }
        ntVariantsCollection(limit: $variantLimit) {
          items {
            sys {
              id
            }
          }
        }
      }
    }
    ntAudienceCollection(limit: $limit) {
      items {
        sys {
          id
        }
        ntAudienceId
        ntName
        ntDescription
      }
    }
  }
`;
